module.exports = __webpack_public_path__ + "z/aboutme-mobile.e04b8b02.png";